import { render, staticRenderFns } from "./EventInfoModal.vue?vue&type=template&id=53c32f35&scoped=true"
import script from "./EventInfoModal.vue?vue&type=script&lang=js"
export * from "./EventInfoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c32f35",
  null
  
)

export default component.exports